module.exports = __webpack_public_path__ + "img/mobile-replenishment.e81e0c53.svg";